import { render } from "./aging-report.vue?vue&type=template&id=fde95f40"
import script from "./aging-report.vue?vue&type=script&lang=js"
export * from "./aging-report.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__